/**
 * 推拿各页 PermissionA5 子树。
 * rootPath: tuinaPage
 */
const tuinaPage = {
  board: {
    buttonCodes: ['tuina:board:control']
  },
  appointments: {
    buttonCodes: ['tuina:appointments:control']
  },
  orders: {
    buttonCodes: ['tuina:orders:control']
  },
  projects: {
    buttonCodes: ['tuina:projects:control']
  },
  technicians: {
    buttonCodes: ['tuina:technicians:control']
  },
  roster: {
    buttonCodes: ['tuina:roster:control']
  },
  members: {
    buttonCodes: ['tuina:members:control']
  }
}

export default tuinaPage
